import React from "react";
import styles from "./InputSkeleton.module.scss";

interface InputSkeletonProps {
    size?: "large" | "medium" | "small" | "xsmall";
}

const InputSkeleton: React.FC<InputSkeletonProps> = ({ size = "medium" }) => {
    return <div className={`${styles.skeleton} ${styles[size]}`} />;
};

export default InputSkeleton;
